import Bar from "libs/preact-chart/Bar";
import ChartCard from "components/Chart/ChartCard";
import bgColors from "./colorsBg";

const options = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      display: false,
    },
  },
};

function ChartBar({ name, data, getReport, style }) {
  const dataSet = [
    {
      label: "Valor",
      data: data.values,
      backgroundColor: bgColors,
    },
  ];

  let height = 300;
  if (window.innerWidth < 400) {
    height = 220;
  }
  const refName = "bar-chart-presik";

  return (
    <ChartCard
      header={name}
      header_meta={data.header_meta}
      desc={data.desc}
      desc_meta={data.desc_meta}
      getReport={getReport}
      style={style}
    >
      <Bar
        refName={refName}
        labels={data.labels}
        dataSet={dataSet}
        options={options}
        height={height}
      />
    </ChartCard>
  );
}

export default ChartBar;
